<script>
    import { Modal } from '../static/bootstrap.js';

    /* import galleryImages from '../static/gallery'; */
    import studioGroup from '../static/studioGrouping';

    import Image from '../elements/image.svelte';

    // const videoRegex = /^.*\.(mp4|mkv)$/;

    /* let sortedStudioGroups = [];
    studioGroup.forEach((image, index) => {
        sortedStudioGroups.push({
            path: image,
            id: image.replaceAll(' ', ''),
        });
    }); */
</script>

<svelte:head>
	<title>studio - wangsichunstudio</title>
</svelte:head>

<div class="illus-wrapper" id="illustrations">
    <div class="page-image"></div>
    <div class="page-content">
        
        <div class="container">
            <h1 class="font-VarelaRound">studio</h1>
        </div>

        <div class="container">
            {#each Object.entries(studioGroup) as [title, images]}
                <div>
                    <h5 class="font-VarelaRound">{title}</h5>

                    {#each images as image}
                    {#if /^.*\.(mp4|ogg)$/.test(image)}
                    <video width="100%" controls>
                        <source src="build/assets/img/studio/{image}" />
                    </video>
                    {:else}
                    <Image
                        src="build/assets/img/studio/{image}"
                        eleclass="img-aspect m-2"
                        on:click={() => new Modal(document.getElementById(image.replaceAll(' ', ''))).toggle()} />

                    <div class="modal fade" id={image.replaceAll(' ', '')}>
                        <div class="modal-dialog modal-dialog-centered modal-dialog-scrollable">
                            <Image src="build/assets/img/studio/{image}" style="max-width:100%;" />
                        </div>
                    </div>
                    {/if}
                    {/each}

                    <hr size="1" />
                </div>
	        {/each}
        </div>

    </div>
</div>

<style lang="scss">
	@import "src/scss/illustrations";
</style>